// @flow

import type { PropsSchema, EasyAction, BasicProps } from '../../type'
import type { Rules } from 'frame/core/formValidate'

import React from 'react'
import computeData from '../hoc/computeData'
import { validate } from 'frame/core/formValidate'
import { compress, base64ToFile } from '../util/compressImg'
import { loading } from 'frame/ui/popup'

type Props = BasicProps & {
  fileField: string,
  base64Field: string,
  rules: Rules,
  formValues: { [string]: string },
  setFormValues: ({ [key: string]: any }) => void,
  style: { [string]: any },
  id: string,
      showLoading:boolean,

};

@computeData()
export default class OpenImg extends React.PureComponent<Props> {
  fileInput: ?HTMLInputElement;

  static schema: PropsSchema = [
    {
      key: 'base64Field',
      title: 'base64字段',
      type: 'text'
    },

    {
      key: 'fileField',
      title: 'file字段',
      type: 'text'
    },
    {
      title: '校验规则列表',
      type: 'array',
      key: 'rules',
      item: [
        {
          type: 'select',
          key: 'type',
          title: '规则：',
          options: [['required', '必填']],
          defaultValue: 'required'
        },
        {
          type: 'text',
          key: 'message',
          title: '提示消息'
        }
      ]
    },
    {
      type: 'boolean',
      key: 'showLoading',
      title: '显示加载效果'
    },
    'separator',
    {
      type: 'event',
      title: '改变',
      event: 'onChange'
    },
    {
      type: 'event',
      title: '用户操作改变',
      event: 'userOperationChange'
    },
    {
      type: 'event',
      title: '图片加载错误',
      event: 'loadError'
    },
    {
      type: 'event',
      title: '校验成功',
      event: 'resolve'
    },
    {
      type: 'event',
      title: '校验失败',
      event: 'reject'
    },
    'separator',
    {
      type: 'style'
    }
  ];

  static actions: EasyAction[] = [
    {
      title: '数据校验',
      name: 'validate'
    },
    {
      title: '清除文件',
      name: 'clearFile'
    }
  ];

  actionClearFile = () => {
    if (this.fileInput) {
      this.fileInput.value = ''
      const { setFormValues, fileField, base64Field } = this.props
      if (fileField) {
        setFormValues({ [fileField]: '' })
      }
      if (base64Field) {
        setFormValues({ [base64Field]: '' })
      }
    }
  };

  actionValidate = () => {
    const { callActions, rules } = this.props
    const fieldValue = this.getFieldValue()
    if (rules && rules.length > 0) {
      const error = validate(fieldValue, rules)
      if (!error.success) {
        callActions('reject', error)
      } else {
        callActions('resolve')
      }
    } else {
      callActions('resolve')
    }
  };

  loading = <T>(promise: Promise<T>, showLoading: boolean): Promise<T> => {
     return showLoading ? loading(promise) : promise
  };
  imageChanged = (event: SyntheticInputEvent<HTMLInputElement>) => {
    const { setFormValues, fileField, base64Field, callActions,showLoading } = this.props
    // const _compress = compress
    // const base64ToFile = base64ToFile
    const file = event.target.files[0]
    if (file) {
      var reader = new window.FileReader()
      reader.readAsDataURL(file)
      this.loading(new Promise(resolve => {
        reader.onload = function () {
          let img = new Image()
          img.src = this.result//base64字符
          img.onload = function () {
            const base64 = compress(img)
            let imgFile
            if (fileField) {
              imgFile = base64ToFile(base64, file.name)
              setFormValues({[fileField]: imgFile})
            }
            if (base64Field) {
              setFormValues({[base64Field]: base64})
            }
            resolve();
            callActions('userOperationChange', base64 || imgFile)
          }
          img.onerror = function (e) {
            resolve('error');
            setTimeout(()=>{
              callActions('loadError', {errorCode: '1'})
            },0)
          }
        }
        reader.onerror = function () {
          resolve('error');
          setTimeout(()=>{
            callActions('loadError', {errorCode: '0'})
          },0)
        }
      }),showLoading)
    }
  };

  getFieldValue = (props?: Props): string => {
    const { base64Field, fileField, formValues } = props || this.props
    return formValues[base64Field || fileField] == null
      ? ''
      : formValues[base64Field || fileField]
  };

  componentDidUpdate (preProps: Props) {
    let { callActions } = this.props
    if (this.getFieldValue(preProps) !== this.getFieldValue()) {
      callActions('onChange', this.getFieldValue())
    }
  }

  render () {
    let { style, id } = this.props
    return (
      <input
        ref={(ref: ?HTMLInputElement) => {
          this.fileInput = ref
        }}
        style={style}
        id={id}
        accept='image/*'
        onChange={e => {
          this.imageChanged(e)
        }}
        type='file'
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/form/FormInputFile.js